module.exports = __webpack_public_path__ + "img/bctt.afe2ec72.png";